<template>
  <div class="w-screen max-w-3xl">
    <div
      class="flex h-full flex-col overflow-y-scroll bg-gray-50 bg-opacity-90 py-6 px-3 shadow-xl backdrop-blur-sm backdrop-opacity-90 backdrop-filter dark:bg-ontick-carbon-500"
    >
      <div class="sticky top-0 mb-6">
        <div class="flex items-start space-x-3">
          <button
            @click="$emit('close')"
            class="focus:outline-none px-1 py-1 text-ontick-carbon-900 hover:text-gray-400 dark:text-gray-400"
          >
            <span v-html="$icons.arrow_left" />
          </button>
          <h1
            class="text-right text-lg font-medium text-ontick-carbon-900 dark:text-gray-300"
          >
            Meus Favoritos
          </h1>
        </div>
      </div>
      <div
        class="mt-10 flex h-full flex-col-reverse items-center justify-center sm:flex-row-reverse"
        v-if="favorite_marketplace.length == 0"
      >
        <div
          class="space-y-6 whitespace-normal text-center text-ontick-carbon-900 dark:text-gray-300 sm:text-left"
        >
          <h2
            class="mt-6 text-2xl font-semibold text-ontick-carbon-700 dark:text-gray-400"
          >
            Nenhum investimento encontrado.
          </h2>
          <p class="items-center">
            Se você gostou de uma estratégia, é só clicar no
            <svg
              class="mx-2 inline"
              width="20"
              height="19"
              viewBox="0 0 20 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.5 0C12.76 0 11.09 0.81 10 2.09C8.91 0.81 7.24 0 5.5 0C2.42 0 0 2.42 0 5.5C0 9.28 3.4 12.36 8.55 17.04L10 18.35L11.45 17.03C16.6 12.36 20 9.28 20 5.5C20 2.42 17.58 0 14.5 0ZM10.1 15.55L10 15.65L9.9 15.55C5.14 11.24 2 8.39 2 5.5C2 3.5 3.5 2 5.5 2C7.04 2 8.54 2.99 9.07 4.36H10.94C11.46 2.99 12.96 2 14.5 2C16.5 2 18 3.5 18 5.5C18 8.39 14.86 11.24 10.1 15.55Z"
                fill="#DD5B5B"
              />
            </svg>
            para adicionar aos favoritos.
          </p>
        </div>
        <span class="ml-3" v-html="favorite"></span>
      </div>
      <div v-if="favorite_marketplace.length > 0" key="cards_robot">
        <div class="grid grid-cols-1 gap-6 overflow-visible xl:grid-cols-2">
          <card-marketplace
            @click.native="
              $emit('details', item.strategies[0].strategy_id, item)
            "
            v-for="(item, index) in favorite_marketplace"
            :key="index"
            :product="item"
            :strategy="item.strategies[0]"
            :favorite="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { favorite } from "@/app/assets/icons/isometric";

export default {
  components: {
    CardMarketplace: () => import("../card/marketplace-card.component.vue"),
  },

  data() {
    return {
      data: [],
      confirm: false,
      noFavoriteMessage: "",
      favorite: favorite,
      options: {
        rewind: false,
        arrows: false,
        pagination: false,
        type: "loop",
        interval: 10000,
        autoplay: true,
        gap: "1.5rem",
        perPage: 4,
        perMove: 4,
        padding: {
          right: "7rem",
          left: "0rem",
        },

        breakpoints: {
          768: {
            perPage: 2,
            gap: "0.5rem",
            padding: {
              right: "4rem",
              left: "0rem",
            },
          },
          1224: {
            perPage: 3,
            gap: "1rem",
          },
        },
      },
    };
  },
  props: {
    active: { type: Boolean, default: false },
  },
  mounted() {
    this.$nextTick(() => {
      this.getMarketplaceFavorite().then((response) => {
        this.noFavoriteMessage = response.msg;
      });
    });
  },
  methods: {
    ...mapActions({
      getMarketplaceFavorite: "marketplace/getMarketplaceFavorite",
    }),
  },

  computed: {
    ...mapState({
      favorite_marketplace: (state) => state.marketplace.favorite_marketplace,
    }),
  },
};
</script>
